import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/body1.jpg"

const description = (
  <div>
    <p style={{ textTransform: "uppercase" }}>
      Anticellulite Treatment (legs and buttocks) Cellulite
    </p>
    <p>
      It is the accumulation of fat in the fat cells of the subcutis. The
      scarcely elastic membranes surrounding them are deformed and pull their
      cutaneous fixation points, leading to bumps. These swelled adipocytes are
      immersed in the plasma fluid, stemming the fundamental substance, which
      then begins to harden. The fundamental substance is extremely rich in
      water but it grows the more viscous and denser the bigger the adipocyte
      is. This leads to stagnation resulting in a net that catches new
      adipocytes which form nodules. These nodules are easily felt by touch and
      form the so-called “orange peel skin”.
    </p>
    <p>
      There are different types of cellulite and many are the factors behind its
      appearance, including hormonal, genetic factors, pour diet, physical
      inactivity or poor circulation and that is why its prevention and
      treatment require taking action and control of more than one factor.
    </p>
    <p>
      It is pointless to work on fat accumulations and adipocytes if we do not
      act on their root causes. Therefore, with Reducel by Freihaut we work on
      three fundamental objectives that are the cause and the consequence of
      cellulite:
    </p>
    <p>
      1. <strong>Action on the blood flow:</strong> stimulation of the blood
      flow using a warm lotion to promote the exchange of fluids in the
      connective tissue.
    </p>
    <p>
      2. 
      <strong>
        Fat dissolution and balancing the metabolism of the adipocyte:
      </strong>
       we achieve these targets by applying serum and cinnamon lotion.
    </p>
    <p>
      3. <strong>Toxin drainage and purification:</strong> improving the
      lymphatic flow to drain and purify all the toxins resulting from fat
      combustion is very important as slow lymphatic flow is the cause and the
      consequence of cellulite.
    </p>
    <p style={{ textTransform: "uppercase" }}>
      Firming Treatment (full body) Body flaccidity
    </p>
    <p>
      This is an alteration of the skin tissue characterised by the loss of tone
      and elasticity.
    </p>
    <p>
      It usually appears as a result of skin ageing but also following a sudden
      loss of weight or after a pregnancy or breastfeeding. They are typically
      located in the area of the abdomen, breasts, thighs, arms, etc.
    </p>
    <p>
      Reducel by Freihaut works on preventing and combating body flaccidity: it
      regenerates connective tissue, nourishes the affected areas and gives
      elasticity to skin as a whole.
    </p>
  </div>
)

const Body = () => (
  <Layout>
    <SEO title="Body treatments" />
    <Treatment image={image} title="Body treatments" htmlText={description} />
  </Layout>
)

export default Body
